import React, { useState } from 'react';
import api from '../services/api';
import { Button, Input, Card } from '../components/ui';

export default function Register() {
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    try {
      await api.post('/users/register', form);
      setMessage('Registro exitoso. Ya puedes iniciar sesión.');
      setForm({ username: '', email: '', password: '' });
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error al registrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center px-4 py-12">
      <div className="absolute inset-0 bg-gradient-to-br from-rs-accent/5 via-transparent to-rs-secondary/5 pointer-events-none" />
      <Card className="relative w-full max-w-md animate-fade-in">
        <div className="text-center mb-6">
          <img src="/logo.png" alt="Reals Store" className="w-20 mx-auto mb-3 drop-shadow-[0_0_18px_rgba(225,6,0,0.45)]" />
          <h1 className="font-display text-3xl tracking-wide text-metallic mb-1">Crear cuenta</h1>
          <p className="text-gray-500">Regístrate para comprar en Reals Store</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Usuario"
            name="username"
            value={form.username}
            onChange={handleChange}
            required
          />
          <Input
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <Input
            label="Contraseña"
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            required
          />
          {message && <div className="text-emerald-400 text-sm py-2">{message}</div>}
          {error && <div className="text-red-400 text-sm py-2">{error}</div>}
          <Button type="submit" fullWidth loading={loading}>
            Registrarse
          </Button>
        </form>
      </Card>
    </div>
  );
}
